import thunk from 'redux-thunk'
import { persistReducer } from "redux-persist"
import storage from 'redux-persist/lib/storage'
import userReducer from "./reducers/userReducer"
import { configureStore } from "@reduxjs/toolkit"
import { combineReducers } from "@reduxjs/toolkit"

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['userState'],
}

const rootReducer = combineReducers({
    userState: userReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk]
})

export default store